import { useMediaQuery } from '@react-hookz/web';

import { P } from '~components/Typography';
import { ButtonPrimary } from '~shared/ui/molecules';

import headerImg from '../../../../../public/img/promo-events/may-4th-event-banner.jpg';
import mobileHeaderImg from '../../../../../public/img/promo-events/may-4th-event-banner-mobile.jpg';
import { promoEventConfig } from '../../config';
import { useIsPromoEventBannerActive } from '../../hooks/useIsPromoEventBannerActive';
import { usePromoCallToAction } from '../../hooks/usePromoCallToAction';
import {
	BannerContainer,
	ButtonContainer,
	ImageContainer,
	Title,
	TopContainer,
} from './styles';

export const PromoEventBanner = () => {
	const hasPromoEventBanner = useIsPromoEventBannerActive();
	const action = usePromoCallToAction();

	const isMobile = useMediaQuery('screen and (max-width: 769px)');
	const imageSource = isMobile ? mobileHeaderImg : headerImg;

	if (!hasPromoEventBanner) {
		return null;
	}
	return (
		<BannerContainer onClick={action}>
			<ImageContainer src={imageSource} alt={'Promo event banner'} />
			<TopContainer>
				<Title weight={500}>She crossed the galaxy for you</Title>
				<P weight={300} size={isMobile ? 'xsmall' : 'medium'}>
					Use code <strong>{promoEventConfig.promoCode}</strong> for 75% off
					neurons
				</P>
			</TopContainer>
			<ButtonContainer>
				<ButtonPrimary
					size={isMobile ? 'small' : 'large'}
					text={'Chat with Zarnah'}
				/>
			</ButtonContainer>
		</BannerContainer>
	);
};
